import React from 'react'
import PropTypes from 'prop-types'

import { priceFormatter } from '../../../Helpers'

const Price = ({ className, price }) => (
  <span className={className}>
    {priceFormatter(price)}
  </span>
)

Price.propTypes = {
  className: PropTypes.string,
  price: PropTypes.number.isRequired,
}

Price.defaultProps = {
  className: undefined,
}

export default Price
